import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Editor from 'components/common/editor/Editor';
import TinyMceEditorSkelton from 'components/utils/TinyMceEditorSkelton';
import { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InsightSummaryFormData } from '../../hooks/useInsightSummaryForm';

type DescriptionProps = {
  edit: boolean;
};

function Description({ edit }: DescriptionProps) {
  const {
    control,
    formState: { isSubmitting },
    setValue,
    watch,
  } = useFormContext<InsightSummaryFormData>();
  const description = watch('description');

  const [showEditor, setShowEditor] = useState(edit || !!description);
  const [isExpanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!showEditor) {
      setShowEditor(edit || !!description);
    }
  }, [description]);

  return (
    <>
      {!showEditor && (
        <Box
          display="flex"
          alignItems="flex-start"
          height={230}
          mb={2}
          sx={{ cursor: 'text' }}
          onClick={() => setShowEditor(true)}
          onFocus={() => setShowEditor(true)}
          tabIndex={0}
        >
          <DescriptionPlaceholder>Add a description</DescriptionPlaceholder>
        </Box>
      )}
      {showEditor && (
        <Box sx={{ mb: 2, position: 'relative' }}>
          <Box sx={{ minHeight: 450, visibility: isExpanded ? 'visible' : 'hidden' }}>
            <Controller
              control={control}
              render={({ field: { ref, onChange, ...field } }) => (
                <Editor
                  {...field}
                  onEditorChange={onChange}
                  onInit={(_, editor) => {
                    ref(editor);
                    setExpanded(true);
                  }}
                  value={!!field.value.trim() ? field.value : ''}
                  disabled={isSubmitting}
                  init={{
                    min_height: 450,
                    height: 450,
                    auto_focus: edit ? undefined : true,
                  }}
                  onBlur={() => {
                    field.onBlur();
                    setValue('description', field.value.trim(), {
                      shouldDirty: true,
                      shouldValidate: true,
                    });
                  }}
                />
              )}
              name="description"
            />
          </Box>
          {!isExpanded && <TinyMceEditorSkelton />}
        </Box>
      )}
    </>
  );
}

const DescriptionPlaceholder = styled(Typography, { label: 'DescriptionPlaceholder' })(
  ({ theme }) => ({
    fontSize: 16,
    color: theme.palette.custom.coolGrey,
  }),
);

export default Description;
